<template>
  <div class="drag-area">
    <draggable
      v-model="widgets"
      v-bind="getSortableOptions()"
    >
      <div v-for="(w, index) in widgets" :key="w.id">
        <item :ref="`w${index}`" :item="w" @remove="emitRemove"/>
      </div>
    </draggable>
  </div>
</template>

<script>
import Draggable from 'vuedraggable'
import Item from './Item'

export default {
  name: "Items",
  components: {
    Draggable,
    Item
  },
  props: {
    value: Array
  },
  computed: {
    widgets: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    getSortableOptions () {
      return {
        handle: '.item-handle',
        dragClass: 'item-drag',
        group: 'draggable',
        animation: 200
      }
    },
    emitRemove (item) {
      this.$emit('remove', item)
    },
    validateAll () {
      const validates = this.widgets.map((w, i) => this.$refs[`w${i}`][0].validateAll())
      return Promise.all(validates).then(all => {
        return all.every(v => v)
      })
    }
  }
}
</script>

<style>
.drag-area {
  min-height:50px;
}
</style>
